module.exports = __webpack_public_path__ + "img/tarj3-8.2cc2e748.svg";